import { render, staticRenderFns } from "./GeneralSettingsForm.vue?vue&type=template&id=faf59c34&"
import script from "./GeneralSettingsForm.vue?vue&type=script&lang=js&"
export * from "./GeneralSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports